// Core
import React from 'react';

// Libraries
import { useTheme } from 'styled-components';
import { useTranslation } from 'react-i18next';

// Types
import { Theme } from '../../../../../../../../types/theme';

// Plugins
import {
  booleanToEnabled,
  booleanToEnableStatus,
  crusherDriveMotorTypeToEnabled,
  crusherDriveMotorTypeToEnableStatus,
} from '../../../../../../../../plugins/crusher';

// Components
import { EnableItem } from '../../../../../../../../components/EnableItem';
import {
  Paragraph,
  ParagraphSize,
  ParagraphWeight,
} from '../../../../../../../../layout/elements/Paragraph';

// Component
import { ControlModeProps } from './ControlMode.types';
import {
  Container,
  EnableItemsContainer,
  LabelsContainer,
  Separator,
} from './ControlMode.style';

function ControlMode({
  className,
  edgeStatus,
  testId,
  unitData,
}: ControlModeProps): JSX.Element {
  // Dependencies
  const { t } = useTranslation();
  const theme: Theme = useTheme();

  return (
    <Container className={className} data-testid={testId}>
      <Paragraph size={ParagraphSize.lg} weight={ParagraphWeight.bold}>
        {t('view.crusher.vsi.maintenance.setup.controlMode.title')}
      </Paragraph>
      <LabelsContainer>
        <Paragraph
          size={ParagraphSize.sm}
          color={
            theme.color.crusherDashboard.maintenance.setup.controlMode.descriptionTextColor
          }
        >
          {t('common.status')}
        </Paragraph>
        <Paragraph
          size={ParagraphSize.sm}
          color={
            theme.color.crusherDashboard.maintenance.setup.controlMode.descriptionTextColor
          }
        >
          {t('common.sensor')}
        </Paragraph>
      </LabelsContainer>
      <Separator />
      <EnableItemsContainer>
        <EnableItem
          description={t('view.crusher.vsi.maintenance.setup.controlMode.crusherDriveMotorType')}
          enabled={crusherDriveMotorTypeToEnabled(unitData?.crusherDriveMotorType)}
          status={crusherDriveMotorTypeToEnableStatus(
            unitData?.crusherDriveMotorType,
            edgeStatus?.edgeStatus ? edgeStatus?.edgeStatus : null,
            unitData?.timestamp ? unitData?.timestamp : null,
          )}
        />
        <EnableItem
          description={t('view.crusher.vsi.maintenance.setup.controlMode.feedControlType')}
          enabled={booleanToEnabled(unitData?.feedControlVfdEnable)}
          status={booleanToEnableStatus(
            unitData?.feedControlVfdEnable,
            edgeStatus?.edgeStatus ? edgeStatus?.edgeStatus : null,
            unitData?.timestamp ? unitData?.timestamp : null,
          )}
        />
        <EnableItem
          description={t('view.crusher.vsi.maintenance.setup.controlMode.feedSuperiorEnable')}
          enabled={booleanToEnabled(unitData?.feedSuperiorEnable)}
          status={booleanToEnableStatus(
            unitData?.feedSuperiorEnable,
            edgeStatus?.edgeStatus ? edgeStatus?.edgeStatus : null,
            unitData?.timestamp ? unitData?.timestamp : null,
          )}
        />
        <EnableItem
          description={t('view.crusher.vsi.maintenance.setup.controlMode.dischargeSuperiorEnable')}
          enabled={booleanToEnabled(unitData?.dischargeSuperiorEnable)}
          status={booleanToEnableStatus(
            unitData?.dischargeSuperiorEnable,
            edgeStatus?.edgeStatus ? edgeStatus?.edgeStatus : null,
            unitData?.timestamp ? unitData?.timestamp : null,
          )}
        />
      </EnableItemsContainer>
    </Container>
  );
}

export { ControlMode };
